import * as React from 'react';

import * as styles from './FormRequestLayout.css';

export const FormRequestLayout = ({
  region,
  phone,
  requirements,
}: {
  region: React.ReactNode;
  phone: React.ReactNode;
  requirements: React.ReactNode;
}): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <div className={styles['line']}>
        <div className={styles['line-item']}>
          <div className={styles['title']}>Где подобрать квартиру</div>
          {region}
        </div>
        <div className={styles['line-item']}>
          <div className={styles['title']}>Куда перезвонить</div>
          {phone}
        </div>
      </div>
      <div className={styles['line']}>
        <div className={styles['line-item']}>
          <div className={styles['title']}>Ваши пожелания</div>
          {requirements}
        </div>
      </div>
    </div>
  );
};
